// src/features/admin/productReturnApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

interface ProductReturnLimitResponse {
  access: boolean;
  message: string;
  return_limit?: string;
  product_id?: number;
}

interface SetProductReturnCountRequest {
  product_id: number;
  return_limit: string;
}

interface SetProductReturnCountResponse {
  access: boolean;
  message: string;
  product_id?: number;
  return_limit?: string;
}

export const productReturnApi = createApi({
  reducerPath: 'productReturnApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER_ENDPOINT || 'https://fftestservice.sarsetech.com',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token') || localStorage.getItem('vendor_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set(
        'authkey', '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3'
      );
      headers.set('Content-Type', 'application/x-www-form-urlencoded');
      return headers;
    },
  }),
  tagTypes: ['ProductReturn'],
  endpoints: (build) => ({
    // Get product-specific return limit
    getProductReturnCount: build.query<ProductReturnLimitResponse, { product_id: number }>({
      query: ({ product_id }) => ({
        url: 'globalsettings/getProductReturnLimit',
        method: 'POST',
        body: new URLSearchParams({
          product_id: product_id.toString()
        }).toString(),
      }),
      providesTags: ['ProductReturn'],
      transformResponse: (response: any) => {
        console.log('Get Product Return Limit Response:', response);
        return response;
      },
    }),
    
    // Set product-specific return limit
    setProductReturnCount: build.mutation<SetProductReturnCountResponse, SetProductReturnCountRequest>({
      query: (data) => {
        const formData = new URLSearchParams();
        formData.append('product_id', data.product_id.toString());
        formData.append('return_limit', data.return_limit);
        
        console.log('Set Product Return Count Request:', data);
        
        return {
          url: 'globalsettings/setProductReturnCount',
          method: 'POST',
          body: formData.toString(),
        };
      },
      invalidatesTags: ['ProductReturn'],
      transformResponse: (response: any) => {
        console.log('Set Product Return Count Response:', response);
        return response;
      },
    }),
  }),
});

export const {
  useGetProductReturnCountQuery,
  useSetProductReturnCountMutation,
} = productReturnApi;